export default {
  // --------------------侧滑表单数据获取-----------------
  formItem: {
    type: Object,
    default: () => {
      return {
        url: '',
        param: '',
        method: 'post',
      }
    },
  },
  modelTitle: {
    type: String,
    default: '数据范围授权',
  },
  specialParamForAddType: {
    type: String,
    default: '',
  },
  // --------------------授权侧滑表格参数-----------------------
  urlQuery: {
    type: String,
    default: '',
  },
  urlQueryParamter: {
    type: Object,
    default: () => {},
  },
  urlQueryMethod: {
    type: String,
    default: 'post',
  },
  modelTableDef: {
    type: Object,
    default: () => {
      return {
        items: [
          {
            prop: 'record.code',
            label: '编码',
            align: 'center',
          },
          {
            prop: 'record.name',
            label: '名称',
            align: 'center',
          },
          {
            prop: 'note',
            label: '备注',
          },
        ],
      }
    },
  },
  modelTableDefUrl: {
    type: String,
    default: '',
  },
  sideModalWidth: {
    type: String,
    default: '700',
  },
  menuDeleteInfo: {
    type: Object,
    default: () => {
      return {
        url: '',
        method: 'post',
        param: '',
      }
    },
  },
  searchPlaceholder: {
    // 侧滑搜索placehoder
    type: Object,
    default: () => {
      return {
        msg: '编码/名称',
        isShow: true,
      }
    },
  },
  sideAddTableUrl: {
    type: Object,
    default: () => {
      return {
        url: '',
        method: 'post',
        param: '',
      }
    },
  },
  // ----------------点击选择展开侧滑sideAdd参数--------------------------
  add_isServerControlChoose: {
    type: Boolean,
    default: false,
  },
  add_selectedArrKey: {
    type: String,
    default: 'id',
  },
  add_sideAddKey: {
    type: String,
    default: 'id',
  },
  add_placeholder: {
    // 点击选择侧滑搜索placehoder
    type: String,
    default: '',
  },
  add_modelTableRequestParam: {
    type: Object,
    default: null,
  },
  add_modelTableRequestMethod: {
    type: String,
    default: '',
  },
  add_modelTableDefUrl: {
    type: String,
    default: '',
  },
  add_modelTableDef: {
    type: Object,
  },
  add_modelTableDataUrl: {
    type: String,
    default: '',
  },
  add_addTableData: {
    type: Object,
    default: () => {
      return {
        url: '',
        param: '',
        method: 'post',
        addKey: '',
      }
    },
  },
  add_modelTitle: {
    type: String,
    default: '',
  },
}
